var render = function render(){var _vm=this,_c=_vm._self._c;return _c('y-layout-body-menu',{attrs:{"aside-width":"8rem","menu":[
  {title:'空码',path:'/card/plugin/wifi/hollow'},
  {title:'wifi码',path:'/card/plugin/wifi/manage'},
  {title:'wifi码模版',path:'/card/plugin/wifi/tpl'},
  {title:'基础配置',path:'/card/plugin/wifi/conf'},
]}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }